"use client";
function waitForSelector(selector) {
  const getElement = () => document.querySelector(selector);
  return new Promise((resolve) => {
    const checkForElement = () => {
      if (getElement()) {
        resolve(getElement());
      } else {
        setTimeout(checkForElement, 5);
      }
    };
    checkForElement();
  });
}

export { waitForSelector };
